"use strict";
var getNative = require('./_getNative'), root = require('./_root');
var Promise = getNative(root, 'Promise');
module.exports = Promise;
//# sourceMappingURL=_Promise.js.map